/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Rest_Api_C2Inputs */

const en_guide_json_rest_api_c2 = /** @type {(inputs: Guide_Json_Rest_Api_C2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Response envelopes, error shapes, status codes`)
};

const ko_guide_json_rest_api_c2 = /** @type {(inputs: Guide_Json_Rest_Api_C2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`응답 껍데기와 오류 형태, 상태 코드`)
};

const ja_guide_json_rest_api_c2 = /** @type {(inputs: Guide_Json_Rest_Api_C2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`レスポンスの包み方、エラーの形、ステータスコード`)
};

/**
* | output |
* | --- |
* | "Response envelopes, error shapes, status codes" |
*
* @param {Guide_Json_Rest_Api_C2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_rest_api_c2 = /** @type {((inputs?: Guide_Json_Rest_Api_C2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Rest_Api_C2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_rest_api_c2(inputs)
	if (locale === "ko") return ko_guide_json_rest_api_c2(inputs)
	return ja_guide_json_rest_api_c2(inputs)
});